import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbs from "../../common/breadcrumbs";
import RewardRules from "./RewardRules";
import Balance from "./Balance";
import Redemptions from "./Redemptions";
import Ledger from "./Ledger";
import { URL } from "../../../constants/URL";
import { useGetRewardTiers } from "../../../queryHooks/useRewards";
import "./rewards.scss";

const RewardsModule = () => {
	const navigate = useNavigate();
	const location = useLocation();

	// Determine active tab based on current path
	const getActiveTab = () => {
		if (location.pathname.includes("balance")) return "balance";
		if (location.pathname.includes("redemptions")) return "redemptions";
		if (location.pathname.includes("ledger")) return "ledger";
		return "rules"; // default to rules
	};

	const activeTab = getActiveTab();
	const { data: tiersResponse } = useGetRewardTiers();
	const tiers = tiersResponse?.status === "success" ? tiersResponse.data : [];

	const tabs = [
		{ id: "rules", label: "Rules", path: URL.rewardRules },
		{ id: "balance", label: "Balance", path: URL.rewardsBalance },
		{ id: "redemptions", label: "Redemptions", path: URL.rewardsRedemptions },
		{ id: "ledger", label: "Ledger", path: URL.rewardsLedger },
	];

	const handleTabChange = (tabId) => {
		const selectedTab = tabs.find((tab) => tab.id === tabId);
		if (selectedTab) {
			navigate(selectedTab.path);
		}
	};

	const renderContent = () => {
		switch (activeTab) {
			case "balance":
				return <Balance />;
			case "redemptions":
				return <Redemptions />;
			case "ledger":
				return <Ledger />;
			case "rules":
			default:
				return <RewardRules />;
		}
	};

	const breadcrumbData = [
		{ label: "Rewards", path: URL.rewards },
		{ label: activeTab === "balance" ? "Balance" : activeTab === "redemptions" ? "Redemptions" : activeTab === "ledger" ? "Ledger" : "Rules" },
	];

	return (
		<div className="rewards-module">
			<BreadCrumbs title="Rewards Management" data={breadcrumbData} />

			<div className="conversion-banner">
				<i className="bx bx-coin-stack" />
				<span className="conversion-label">Redemption Ladder</span>
				{tiers.length ? (
					<span className="ladder-tiers">
						{tiers.map((tier) => (
							<span key={tier.id} className="ladder-tier" title={`${tier.centsPerPoint.toFixed(2)}¢ per point`}>
								<strong>{tier.points.toLocaleString()}</strong> = ${tier.creditAmount}
							</span>
						))}
					</span>
				) : (
					<strong>600 Points = $10</strong>
				)}
				<span className="conversion-note">Credit valid 30 days from redeem. Points roll over.</span>
			</div>

			<div className="module-container">
				<div className="module-tabs">
					<div className="tabs-header">
						{tabs.map((tab) => (
							<button
								key={tab.id}
								className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
								onClick={() => handleTabChange(tab.id)}
							>
								{tab.label}
							</button>
						))}
					</div>
				</div>

				<div className="module-content">
					{renderContent()}
				</div>
			</div>
		</div>
	);
};

export default RewardsModule;
